export function updateUrlParams (key, value) {
  if (history.pushState) {
    const params = new URLSearchParams(window.location.search);
    params.set(key, value);
    const newUrl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + params.toString();
    window.history.pushState({ path: newUrl }, '', newUrl);
  }
}

export function deleteUrlParam (key) {
  if (history.pushState) {
    const params = new URLSearchParams(window.location.search);
    if (params.get(key)) {
      params.delete(key);
      const newUrl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + params.toString();
      window.history.pushState({ path: newUrl }, '', newUrl);
    }
  }
}
